<section class="register">
    <div class="register-header-container">
        <h1 class="account-registration">{{ 'teacherRegistration.accountRegisterHeader' | translate }}</h1>
        <p class="register-type-text">{{ 'teacherRegistration.registerTypeText' | translate }}</p>
    </div>
    <div class="register-container" *ngIf="isRegistrationHomePage">
        <div class="register-panel">
            <h2 class="register-header">{{ teacherHeader }}</h2>
            <p class="register-info-text">{{ teacherRegistrationText }}</p>
            <cel-button class="register-button" data-regular="true" data-label="Register"
                (click)="navigateToTeacherRegistrationPage()" data-aria-label="Register Teacher">
            </cel-button>
        </div>
        <div class="register-panel">
            <h2 class="register-header">{{ adminHeader }}</h2>
            <p class="register-info-text">{{ adminRegistrationText }}</p>
            <cel-button class="register-button" data-regular="true" data-label="Register"
                (click)="navigateToAdminRegistrationPage()" data-aria-label="Register Administrator">
            </cel-button>
        </div>
    </div>
    <p class="student-login-text">
        <span class="students">{{'teacherRegistration.students' | translate}}</span>
        <span>{{ 'teacherRegistration.studentInfoText' | translate }}</span>
        <a class="signin-link" href="javascript: void(0)" (click)="navigateToSignInPage()">{{'teacherRegistration.signInText' | translate}}</a>
    </p>
</section>
